/** Kerangka (skeleton) dengan ukuran mendekati konten asli agar tidak ada layout shift. */
const Blok = ({ className = "" }) => (
  <div className={`animate-pulse rounded-[4px] bg-[#E5E5EA] ${className}`} />
);

export const HeroSkeleton = () => (
  <section className="w-full" data-testid="skeleton-hero">
    <div className="w-full aspect-[2/1] md:aspect-[21/5] animate-pulse bg-[#E5E5EA]" />
  </section>
);

export const ProductCardSkeleton = () => (
  <div className="overflow-hidden rounded-[4px] bg-white">
    <div className="aspect-square animate-pulse bg-[#E5E5EA]" />
    <div className="space-y-2 p-3">
      <Blok className="h-4 w-11/12" />
      <Blok className="h-4 w-2/3" />
      <Blok className="mt-3 h-9 w-full" />
    </div>
  </div>
);

export const ProductGridSkeleton = ({ jumlah = 8, kolom = "grid-cols-2 md:grid-cols-4" }) => (
  <div className={`grid gap-3 md:gap-6 ${kolom}`} data-testid="skeleton-grid">
    {Array.from({ length: jumlah }).map((_, i) => <ProductCardSkeleton key={i} />)}
  </div>
);

export const BestSellersSkeleton = () => (
  <section className="min-h-[806px] px-4 pt-6 pb-2 md:min-h-[583px] md:px-20 md:py-6" data-testid="skeleton-terlaris">
    <div className="mx-auto w-full max-w-[1280px]">
      <Blok className="h-8 w-56 md:h-9 md:w-64" />
      <div className="mt-4 md:mt-6"><ProductGridSkeleton jumlah={4} /></div>
    </div>
  </section>
);

export const BannerSkeleton = () => (
  <section className="min-h-[268px] px-4 py-6 md:min-h-[345px] md:px-20" data-testid="skeleton-banner">
    <div className="mx-auto h-[220px] w-full max-w-[1280px] animate-pulse bg-[#E5E5EA] md:h-[297px]" />
  </section>
);

export const SmallBannersSkeleton = () => (
  <section className="min-h-[384px] px-4 py-6 md:min-h-[228px] md:px-20" data-testid="skeleton-banner-kecil">
    <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-4 md:grid-cols-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="h-[107px] animate-pulse bg-[#E5E5EA] md:h-[180px]" />
      ))}
    </div>
  </section>
);

export const TestimonialsSkeleton = () => (
  <section className="min-h-[637px] px-4 py-8 md:min-h-[724px] md:px-20" data-testid="skeleton-ulasan">
    <div className="mx-auto w-full max-w-[1280px]">
      <Blok className="h-8 w-60" />
      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="space-y-2 rounded-[4px] bg-white p-4">
            <Blok className="h-4 w-1/2" />
            <Blok className="h-3 w-full" />
            <Blok className="h-3 w-5/6" />
            <Blok className="h-3 w-3/4" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ArticleListSkeleton = ({ jumlah = 4 }) => (
  <div className="mt-8 space-y-6" data-testid="skeleton-artikel">
    {Array.from({ length: jumlah }).map((_, i) => (
      <div key={i} className="space-y-2">
        <Blok className="h-6 w-3/4" />
        <Blok className="h-4 w-full" />
        <Blok className="h-4 w-2/3" />
      </div>
    ))}
  </div>
);

export const ProductDetailSkeleton = () => (
  <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-8 md:grid-cols-2 md:px-20" data-testid="skeleton-produk">
    <div className="aspect-square animate-pulse rounded-[4px] bg-[#E5E5EA]" />
    <div className="space-y-3">
      <Blok className="h-9 w-4/5" />
      <Blok className="h-5 w-1/3" />
      <Blok className="h-24 w-full" />
      <Blok className="h-12 w-2/3" />
      <Blok className="h-12 w-full" />
    </div>
  </div>
);

export default Blok;
